import React from 'react';

const styles = {
 
  header: {
    fontSize: '18px'
  },
  hr: {
    borderTop: '1px solid #bbb',
    marginTop: '10px',
    marginBottom: '10px'
  }
}

export default ({ content, hidden }) => {
  return <div style={styles.container} className={`${hidden ? 'hidden' : ''}`}>
    <hr style={styles.hr}/>
    <strong style={styles.header}>{ content }</strong>
  </div>
}


// WEBPACK FOOTER //
// ./src/components/horizontal-rule-with-content.js